import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  CircularProgress,
  Alert,
  Tabs,
  Tab,
} from '@mui/material';

// Tab Panel component
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const RestaurantDetails = () => {
  const { restaurantId } = useParams();
  const [restaurant, setRestaurant] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    const fetchRestaurant = async () => {
      try {
        setLoading(true);
        // In a production app, you would fetch from your API
        setRestaurant({
          id: restaurantId,
          name: "Sample Restaurant",
          description: "This is a sample restaurant for the demo",
          address: {
            street: "123 Main St",
            city: "New York",
            state: "NY",
            zipCode: "10001",
          },
          cuisine: "Italian",
          priceRange: "$$",
          rating: {
            average: 4.5,
            count: 120
          },
          openingHours: "9:00 AM - 10:00 PM"
        });
        setLoading(false);
      } catch (err) {
        console.error('Error fetching restaurant:', err);
        setError('Failed to fetch restaurant details. Please try again later.');
        setLoading(false);
      }
    };

    if (restaurantId) {
      fetchRestaurant();
    }
  }, [restaurantId]);

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      {restaurant && (
        <>
          <Box sx={{ mb: 4 }}>
            <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
              <Typography variant="h4" component="h1" gutterBottom>
                {restaurant.name}
              </Typography>
              <Typography variant="body1" color="textSecondary" paragraph>
                {restaurant.description}
              </Typography>
              <Typography variant="body1" color="textSecondary">
                {restaurant.address.street}, {restaurant.address.city}, {restaurant.address.state} {restaurant.address.zipCode}
              </Typography>
              <Typography variant="body1" color="textSecondary">
                {restaurant.cuisine} • {restaurant.priceRange} • ⭐ {restaurant.rating.average} ({restaurant.rating.count} reviews)
              </Typography>
            </Paper>
          </Box>
          
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={tabValue} onChange={handleChangeTab} aria-label="restaurant tabs">
              <Tab label="Details" />
              <Tab label="Floor Plan" />
              <Tab label="Menu" />
              <Tab label="Reservations" />
            </Tabs>
          </Box>
          
          <TabPanel value={tabValue} index={0}>
            <Paper elevation={2} sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                Restaurant Information
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle1">Opening Hours</Typography>
                  <Typography variant="body2" color="textSecondary">
                    {restaurant.openingHours}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle1">Cuisine</Typography>
                  <Typography variant="body2" color="textSecondary">
                    {restaurant.cuisine}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </TabPanel>
          
          <TabPanel value={tabValue} index={1}>
            <Paper elevation={2} sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                Floor Plan Editor
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Floor plan editor will be implemented here.
              </Typography>
            </Paper>
          </TabPanel>
          
          <TabPanel value={tabValue} index={2}>
            <Paper elevation={2} sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                Menu Editor
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Menu editor will be implemented here.
              </Typography>
            </Paper>
          </TabPanel>
          
          <TabPanel value={tabValue} index={3}>
            <Paper elevation={2} sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                Reservations
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Reservations list will be displayed here.
              </Typography>
            </Paper>
          </TabPanel>
        </>
      )}
    </Container>
  );
};

export default RestaurantDetails; 